<template>
    <div class="Personalprofile">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">综合查询</label>
                    <el-input v-model="param.realName" placeholder="请输入用户昵称" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">创建时间</label>
                    <el-date-picker    
                    class="autowidth"
                    clearable
                    v-model="Finalpaymenttime"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">性别</label>
                    <el-select v-model="param.sex" placeholder="请选择" filterable  class="autowidth" clearable >
                        <el-option label="女" value="0"></el-option>
                        <el-option label="男" value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="16" style="margin-top: 10px;">
                    <label class="headerlabel">单位</label>
                    <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID" class="autowidth"
                filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable></el-cascader>
                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="UserData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column label="序号">
                    <template slot-scope="scope" center>
                            {{ (param.pageIndex - 1) * 10 + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="UserID" label="学号"></el-table-column>
                <el-table-column prop="RealName" label="姓名"></el-table-column>
                <el-table-column prop="Sex" label="性别"></el-table-column>
                <el-table-column prop="age" label="年龄"></el-table-column>
                <el-table-column prop="DeptName" label="单位"></el-table-column>
                <el-table-column prop="CreatedDate" sortable label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right: 10px;" @click="$router.push('/psychometrics/Overallarchivereport?userID='+scope.row.UserID)">查看档案</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            Finalpaymenttime:[],
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                realName: "",
                createdTimeBegin: "",
                createdTimeEnd:'',
                sex:'',
                deptID:''
            },
            UserData:[],
            MemeberPackageData:[],
            optionsnew: [],
            DeptID:''
        }
    },
    watch:{
        Finalpaymenttime(newval,oldval){
            if(newval==null){
                this.param.createdTimeBegin=''
                this.param.createdTimeEnd=''
            }else{
                this.param.createdTimeBegin=newval[0]
                this.param.createdTimeEnd=newval[1]
            }
        },
    },
    created() {
        this.initDep();
    },
    methods:{
        init(){
            this.loading=true;
            this.param.deptID=this.DeptID;
            this.$Http_Post('/userprofile/getuserlist',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0 || res.Code==200){
                    this.param.PageTotal=res.Counts;
                    this.UserData=res.Data.Lists;
                    console.log(res.Data);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        GetNodeByDeptID(ID, NodeList) {
            let obj = null
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                obj = NodeList[i]
                break
                } else if (
                NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
                ) {
                obj = this.GetNodeByDeptID(ID, NodeList[i].children);
                if (obj != null) break
                }
            }
            return obj
        },
        bumen(dt) {
            let obj = this.optionsnew[0];
            for (let i = 0; i < this.optionsnew.length; i++) {
                if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
                obj = this.optionsnew[i];
                break;
                } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
                obj = this.GetNodeByDeptID(
                    dt[dt.length - 1],
                    this.optionsnew[i].children
                );
                }
            }

            let _this = this;
            if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
                obj.children = [{ label: this.$t('original.languages22') }];
                this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
                if (res.Code == 200 || res.Code == 0 && res.Data) {
                    obj.children = res.Data;
                }
                });
            }
            },
            Selected_to_shut_dow(dt) {
            this.DeptID = dt[dt.length - 1];
            this.$refs.wcascader.dropDownVisible = false;
        },
        initDep(){
            this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '', }).then((res) => {
                if (res.Data) {
                    this.optionsnew = res.Data;
                    this.DeptID = res.Data[0].DeptID;
                    this.param.deptID = res.Data[0].DeptID;
                    this.init();
                }
            });
        }
    },
}
</script>
<style scoped>
.Personalprofile .header{background: #fff;padding:20px;}
.Personalprofile .header .headerlabel{width:90px;display: inline-block;}
.Personalprofile .header .autowidth{width: 240px;}
.Personalprofile .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Personalprofile .ruleContent {margin: 0 20px;}
.Personalprofile .ruleContent .item{padding-top: 15px;}
.Personalprofile .ruleContent .item label{margin-right: 15px;}
</style>